// extracted by mini-css-extract-plugin
export var textInput = "_ju-0";